function onClickOutside(el, fn, options) {
  ensureTabIndex(el);
  if ((options == null ? void 0 : options.focus) !== false) {
    el.focus();
  }
  const handler = makeFocusOutHandler(fn);
  el.addEventListener("focusout", handler);
  return () => el.removeEventListener("focusout", handler);
}
function makeFocusOutHandler(fn) {
  return (event) => {
    const evt = event;
    if (!focusLost(evt)) {
      return;
    }
    fn(evt.relatedTarget, evt);
  };
}
function ensureTabIndex(el) {
  if (el.getAttribute("tabindex") === null) {
    el.tabIndex = -1;
  }
}
function focusLost(event) {
  const { currentTarget, relatedTarget } = event;
  if (!currentTarget) {
    return false;
  }
  if (!relatedTarget) {
    return true;
  }
  return currentTarget !== relatedTarget && !currentTarget.contains(relatedTarget);
}

export { makeFocusOutHandler, onClickOutside };
